import React from 'react';
import { FadeIn } from './ui/FadeIn';
const seasons = [{
  name: 'Fase Menstrual',
  desc: 'El invierno de tu cuerpo. Momento de drenar, recuperar y priorizar el movimiento suave.',
  color: 'border-emerald-700'
}, {
  name: 'Fase Folicular',
  desc: 'Tu primavera. Hormonas anabólicas en aumento. Ideal para empezar a levantar pesado.',
  color: 'border-emerald-500'
}, {
  name: 'Fase Ovulatoria',
  desc: 'Tu verano. Pico de energía y fuerza. El momento exacto para romper tus récords personales.',
  color: 'border-gold-400'
}, {
  name: 'Fase Lútea',
  desc: 'Tu otoño. El cuerpo se prepara para descansar. Bajar intensidad es clave para evitar inflamación.',
  color: 'border-gold-600'
}];
export function MechanismSection() {
  return <section className="py-24 bg-emerald-950 relative overflow-hidden" data-id="element-112">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-113" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-114">
        <FadeIn data-id="element-115">
          <div className="text-center mb-16" data-id="element-116">
            <h2 className="text-sm md:text-base text-gold-400 font-bold tracking-widest mb-4 uppercase" data-id="element-117">
              El Mecanismo Único
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-118">
              El Entrenamiento de Resistencia Basado en Fases{' '}
              <span className="text-gradient-gold" data-id="element-119">(ERBF)</span>
            </h3>
            <p className="text-lg md:text-xl text-emerald-50/80 max-w-3xl mx-auto font-body" data-id="element-120">
              Este método divide tu mes en 4 estaciones biológicas. Aprendes a
              levantar pesado cuando tus hormonas son anabólicas y a priorizar
              la recuperación inteligente cuando tu cuerpo necesita drenar
              inflamación. Es sincronización fisiológica para que tu metabolismo
              trabaje A FAVOR de tus resultados.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative" data-id="element-121">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-emerald-800 via-gold-500/50 to-emerald-800 -translate-y-1/2 z-0" data-id="element-122" />

          {seasons.map((season, index) => <FadeIn key={index} delay={0.1 * (index + 1)} className="relative z-10" data-id="element-123">
              <div className={`bg-emerald-900 border-t-4 ${season.color} p-8 rounded-b-xl shadow-lg h-full flex flex-col items-center text-center transform transition-transform hover:-translate-y-2`} data-id="element-124">
                <div className={`w-12 h-12 rounded-full border-2 ${season.color} bg-emerald-950 flex items-center justify-center mb-6 font-heading font-bold text-xl`} data-id="element-125">
                  {index + 1}
                </div>
                <h4 className="text-xl font-bold mb-4 text-white" data-id="element-126">
                  {season.name}
                </h4>
                <p className="text-emerald-100/70 font-body text-sm leading-relaxed" data-id="element-127">
                  {season.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}